<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3" >
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						
						<el-form-item v-if="type=='2' || type=='3'" :label="$t('payList.uid')" class="mb-0">
							<el-input size="small" v-model="from.uid" ></el-input>
						</el-form-item>
						<!-- <el-form-item :label="$t('userList.userName')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item> -->
						<el-form-item v-if="type=='3'" :label="$t('adminList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item>
						<!-- <el-form-item :label="$t('accountList.isFp')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.yes')" :value="1"></el-option>
								<el-option :label="$t('accountList.no')" :value="0"></el-option>
							</el-select>
						</el-form-item> -->
						
						<!-- <el-form-item :label="$t('acapplyList.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('acapplyList.dai')" :value="0"></el-option>
								<el-option :label="$t('acapplyList.yes')" :value="1"></el-option>
								<el-option :label="$t('acapplyList.no')" :value="2"></el-option>
								<el-option :label="$t('acapplyList.close')" :value="3"></el-option>
								
							</el-select>
						</el-form-item> -->
						
						
						<!-- <el-form-item :label="$t('dayList.agent')" class="mb-0">
							<el-select v-model="from.agent_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.agent" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item> -->
						
						<el-form-item :label="$t('accountList.cloudName')" class="mb-0">
							<el-select v-model="from.cloud_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<!-- <el-form-item :label="$t('new1.sup')" class="mb-0">
							<el-select v-model="from.sup_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item> -->
						
						<el-form-item :label="$t('dayList.time')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
								  :picker-options="layout.pickerOptions"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<!-- <div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('accountList.addAccount')}}</el-button>
					</div> -->
			</template>
		</div>
		
		<!-- <el-tabs v-model="type" @tab-click="handleClick">
		    <el-tab-pane :label="$t('dayList.agent_data')" name="1"></el-tab-pane>
		    <el-tab-pane :label="$t('dayList.user_data')" name="2"></el-tab-pane>
		    <el-tab-pane :label="$t('dayList.account_data')" name="3"></el-tab-pane>
		  </el-tabs> -->
		  
		  
		  
		  <el-tabs v-if="type=='3'" v-model="ac_type" type="card" @tab-click="handleClick">
		  <el-tab-pane :label="$t('accountList.type1')" name="zhu"></el-tab-pane>
		  <el-tab-pane :label="$t('accountList.type2')" name="ci"></el-tab-pane>
		</el-tabs>
		<!-- 表格 -->
		<div class="" style="padding-bottom:20px; overflow-y: auto;" >
			<el-table show-summary :summary-method="getSummaries" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				
				<el-table-column :fixed="tableData.length?'left':''"  align="center" prop="name"  :label="type=='1'?$t('dayList.agent'):type=='2'?$t('userList.userName'):type=='3'?$t('login.username'):''" :width="tableData.length?type=='3'?140:90:'auto'">
					
					<template slot-scope="scope">
						<el-link v-if="type=='2'" @click="layout.openUserInfo(scope.row.id)" type="primary" class="text_chengse">{{scope.row.name}}</el-link>
						<span v-else>{{scope.row.name}}</span>
						
					</template>
					
					
				</el-table-column>
				
				
				<!-- <el-table-column v-if="type=='3'"   align="center" prop="c_name"  :label="$t('accountList.cloudName')" width="90">
				</el-table-column> -->
				
				
				<!-- 动态日期列 -->
				    <el-table-column
				      v-for="date in dateColumns"
				      :key="date"
				      :prop="'cloud_name.' +date"
				      :label="date"
				      align="center"
				    >
				    </el-table-column>
					
					<el-table-column :fixed="tableData.length?'right':''"  align="center" prop="total"  :label="$t('dayList.total')" :width="tableData.length?90:'auto'">
						
						
						<template slot-scope="scope">
							<el-link  @click="toOrder(type,scope.row)" type="primary" class="text_chengse">{{scope.row.total}}</el-link>
							
							
						</template>
					</el-table-column>
				
				
				
				
			</el-table>
			
			
			<!-- 统计图容器 -->
			<el-card class="box-card h_100  mt-3"  shadow="hover">
				<div slot="header" class="clearfix">
					<span>{{$t('tool.name')}}</span>
				</div>
				
				<!-- 统计图容器 -->
				<div ref="myChart" style="width: 100%;height: 400px;">
				
				</div>
				
			</el-card>
		</div>
		
		
	



		<!-- <el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer> -->

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('acapplyList.notitle') : $t('accountList.addAccount')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
			
				
				<el-form-item :label="$t('acapplyList.remark')" prop="remark">
					<el-input v-model="form.remark" :placeholder="$t('acapplyList.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	import echarts from 'echarts'
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				ac_type:"ci",
				
				type:'3',
				createModel: false,
				editIndex: -1,
				
				//搜索數据
				from: {
					uid:'',
					name: '',
					username:'',
					status:-1,
					sup_id:-1,
					agent_id:-1,
					cloud_id:-1,
					time:[],
				},
				auth_val: 'Admin',

				preUrl: "data/totalList", //列表地址
				delAllUrl: "data/delAccountApplyAll", //批量删除地址
				delUrl: "data/delAccountApply", //删除單条地址
				addUrl: "data/addAccountApply", //添加/修改地址
				editStatusUrl:"data/editStatusAccountApply",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				rules: {
					remark: [{
						required: true,
						message: this.$t('acapplyList.inpRemark'),
						trigger: 'blur',
					}],
					
				},
				rule_list: [],
				check_img_list:[],
				total_money:[],
				order_money:[],
				odds_money:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
			
			dateColumns() {
			  // 获取所有日期列
			  if (!this.tableData.length) return [];
			  return Object.keys(this.tableData[0].cloud_name);
			}
		},
		created() {
			this.commonList('total');
		},
		methods: {
			toOrder(type,item){
				
				let totalToOrder = {}
				totalToOrder.agent_id = -1
				totalToOrder.username = ''
				if(type=='1'){
					totalToOrder.agent_id = item.id
				}
				if(type=='2'){
					totalToOrder.name = item.id
				}
				if(type=='3'){
					totalToOrder.username = item.username
				}
				this.$router.push({
					name: 'order',
					params:{totalToOrder:totalToOrder}
				})
			},
			// 绘制 ECharts 图表
			    drawLine() {
			      if (!this.$refs.myChart) return;
			      let myChart = echarts.init(this.$refs.myChart);
			
			      myChart.setOption({
			        tooltip: {
			          trigger: "axis",
			          axisPointer: { type: "cross" }
			        },
			        toolbox: {
			          feature: {
			            dataView: { show: true, readOnly: false ,title:this.$t('tool.data')},
			            magicType: { show: true, type: ["line", "bar"],title:{
							line:this.$t('tool.line'),
							bar:this.$t('tool.bar')
						} },
			            restore: { show: true ,title:this.$t('tool.restore')},
			            saveAsImage: { show: true,title:this.$t('tool.down_img') }
			          }
			        },
			        legend: { data: [this.$t('dayList.order_money'),this.$t('dayList.odds_money'),this.$t('dayList.total_money')] },
					grid:{
					  left: 50,
					  right: 30,
					  top: 80,
					  bottom: 50
					},
			        xAxis: {
			          type: "category",
			          data: this.dateColumns, // 使用日期作为 X 轴
			          axisPointer: { type: "shadow" }
			        },
			        yAxis: {
			          type: "value",
			          name: this.$t('dayList.money'),
			          axisLabel: { formatter: "{value}" }
			        },
			        series: [
			         
					  {
					    name: this.$t('dayList.order_money'),
					    type: "bar",
					    data: this.order_money, // 使用计算出的合计数据
							itemStyle: {
							  color: "#5972c1" // 设置柱状图颜色
							},
					    tooltip: {
					      valueFormatter: value => value
					    }
					  },
					  {
					    name: this.$t('dayList.odds_money'),
					    type: "line",
					    data: this.odds_money, // 使用计算出的合计数据
							itemStyle: {
							  color: "#f3c96b" // 设置柱状图颜色
							},
					    tooltip: {
					      valueFormatter: value => value
					    }
					  },
					  {
					    name: this.$t('dayList.total_money'),
					    type: "bar",
					    data: this.total_money, // 使用计算出的合计数据
								itemStyle: {
								  color: "#9ec97e" // 设置柱状图颜色
								},
					    tooltip: {
					      valueFormatter: value => value
					    }
					  }
			        ]
			      });
			    },
			getSummaries({ columns, data }) {
				
			      const sums = [];
			
			      columns.forEach((column, index) => {
			        if (index === 0) {
			          sums[index] = this.$t('dayList.total'); // 第一列固定 "合计"
			          return;
			        }
					
					// if(this.type=='3'){
					// 	if (index === 1) {
					// 	  sums[index] = '-'; // 第一列固定 "合计"
					// 	  return;
					// 	}
					// }
			
			        const columnKey = column.property; // 获取列 prop，例如 'cloud_name.2025-03-19'
			
			        const total = data.reduce((sum, row) => {
			          const value = columnKey.split('.').reduce((obj, key) => obj?.[key], row);
			          return sum + (isNaN(value) ? 0 : Number(value));
			        }, 0);
			
			        sums[index] = total.toFixed(2);
			      });
			
			      // 移除第一列（"合计"），只保留数值部分
				  this.$nextTick(() => {
				      this.drawLine();
				    });
			      //this.drawLine(); // 计算完成后重新绘制图表
			      return sums;
			    },
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 2
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form,true)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				
		
				// 增加
				
				if (!e) {
					return false;
				} else {
					// 修改
					this.form = {
						id:e.id,
						remark:''
					}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list
					console.log(res)
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_money = e.total_money
				this.order_money = e.order_money
				this.odds_money = e.odds_money
				
				console.log(e.total_money)
				
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
				
				this.drawLine()
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					uid:'',
					name: '',
					username:'',
					status:-1,
					agent_id:-1,
					cloud_id:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
